// extracted by mini-css-extract-plugin
export default {"footer":"footer_fx75T","footerLinks":"footerLinks_JPjUB","footerLinksElement":"footerLinksElement_xQAtg","footerCopyright":"footerCopyright_Xomet"};